// extracted by mini-css-extract-plugin
module.exports = {"component":"CreateRule_component__3MnV_","close":"CreateRule_close__2d9LT"};